__turbopack_context__.v({
  "container": "Container-module__QakJAa__container",
});
